import { Component, OnInit } from '@angular/core';
import { WorklogFilterService } from '../../services/worklog-filter.service';
import { HelperService } from '../../services/helper.service';

/**
 * Worklog Sidenav Component
 * See docs/worklog-editor/05-components.md
 */
@Component({
  selector: 'app-worklog-sidenav',
  templateUrl: './worklog-sidenav.component.html',
  styleUrls: ['./worklog-sidenav.component.scss']
})
export class WorklogSidenavComponent implements OnInit {
  isUAT = false;

  // Filter states
  recurringFilter: 'all' | 'recurring' | 'non-recurring' = 'all';
  statusFilter: 'pending' | 'all' | 'completed' = 'pending';
  residentFilter: string | null = null;

  // Menu visibility
  showRecurringMenu = false;
  showStatusMenu = false;
  showResidentMenu = false;

  // Button positions for menus
  recurringButtonTop = 0;
  statusButtonTop = 0;
  residentButtonTop = 0;

  // Filter options
  recurringOptions = [
    { icon: 'view_list', tooltip: 'All Activities', value: 'all' },
    { icon: 'repeat', tooltip: 'Recurring Only', value: 'recurring' },
    { icon: 'repeat_one', tooltip: 'Non-Recurring Only', value: 'non-recurring' }
  ];

  statusOptions = [
    { icon: 'pending_actions', tooltip: 'Pending Only', value: 'pending' },
    { icon: 'checklist', tooltip: 'All Statuses', value: 'all' },
    { icon: 'check_circle', tooltip: 'Completed/Not Doing', value: 'completed' }
  ];

  residentOptions: { icon: string, tooltip: string, value: string | null }[] = [
    { icon: 'people', tooltip: 'All Residents', value: null }
  ];

  constructor(
    private worklogFilterService: WorklogFilterService,
    private helperService: HelperService
  ) {}

  ngOnInit(): void {
    // Load environment
    const savedEnv = this.helperService.getStoredValue('ecase_env', 'prod');
    this.isUAT = savedEnv === 'uat';

    // Load saved filters
    const filterState = this.worklogFilterService.getFilterState();
    this.recurringFilter = filterState.recurringFilter;
    this.statusFilter = filterState.statusFilter;
    this.residentFilter = filterState.residentFilter;
  }

  onRecurringOptionSelected(value: string): void {
    this.recurringFilter = value as any;
    this.worklogFilterService.setRecurringFilter(this.recurringFilter);
    this.showRecurringMenu = false;
  }

  onStatusOptionSelected(value: string): void {
    this.statusFilter = value as any;
    this.worklogFilterService.setStatusFilter(this.statusFilter);
    this.showStatusMenu = false;
  }

  onResidentOptionSelected(value: string | null): void {
    this.residentFilter = value;
    this.worklogFilterService.setResidentFilter(this.residentFilter);
    this.showResidentMenu = false;
  }

  toggleEnvironment(): void {
    this.isUAT = !this.isUAT;
    const newEnv = this.isUAT ? 'uat' : 'prod';
    this.helperService.storeValue('ecase_env', newEnv);
    window.location.reload();
  }

  resetFilters(): void {
    this.worklogFilterService.resetFilters();
    const filterState = this.worklogFilterService.getFilterState();
    this.recurringFilter = filterState.recurringFilter;
    this.statusFilter = filterState.statusFilter;
    this.residentFilter = filterState.residentFilter;
  }

  getRecurringIcon(): string {
    return this.recurringFilter === 'recurring' ? 'repeat'
         : this.recurringFilter === 'non-recurring' ? 'repeat_one'
         : 'view_list';
  }

  getStatusIcon(): string {
    return this.statusFilter === 'pending' ? 'pending_actions'
         : this.statusFilter === 'completed' ? 'check_circle'
         : 'checklist';
  }

  getResidentIcon(): string {
    return this.residentFilter ? 'person' : 'people';
  }

  getRecurringTooltip(): string {
    const option = this.recurringOptions.find(o => o.value === this.recurringFilter);
    return option ? option.tooltip : '';
  }

  getStatusTooltip(): string {
    const option = this.statusOptions.find(o => o.value === this.statusFilter);
    return option ? option.tooltip : '';
  }

  getResidentTooltip(): string {
    const option = this.residentOptions.find(o => o.value === this.residentFilter);
    return option ? option.tooltip : 'All Residents';
  }

  onButtonMouseEnter(event: MouseEvent, menu: string): void {
    const target = event.currentTarget as HTMLElement;
    const rect = target.getBoundingClientRect();

    switch(menu) {
      case 'recurring':
        this.recurringButtonTop = rect.top;
        this.showRecurringMenu = true;
        break;
      case 'status':
        this.statusButtonTop = rect.top;
        this.showStatusMenu = true;
        break;
      case 'resident':
        this.residentButtonTop = rect.top;
        this.showResidentMenu = true;
        break;
    }
  }

  onButtonMouseLeave(menu: string): void {
    setTimeout(() => {
      switch(menu) {
        case 'recurring':
          this.showRecurringMenu = false;
          break;
        case 'status':
          this.showStatusMenu = false;
          break;
        case 'resident':
          this.showResidentMenu = false;
          break;
      }
    }, 200);
  }
}
